import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'session-calendar-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    providers: [TranslatePipe],
})
export class SessionCalendarCardComponent implements OnInit {
    @Input() session: any;

    options: any = '-';
    confirmed: any = '-';

    display = true;

    constructor() {}

    colorStyle(): string {
        let styles;
        if (this.session.locationType === 'REMOTE') {
            styles = ['remote'];
        } else {
            styles = [this.session.intra ? 'intra' : 'inter'];
        }

        const locationName = this.session.roomAgencyName;
        const locationClass = locationName
            ? locationName.substr('Zenika '.length).toLowerCase()
            : undefined;

        if (locationClass) {
            styles.push(locationClass);
        }

        return styles.join(' ');
    }

    hasLocation(): boolean {
        return (
            !!this.session.companyName ||
            !!this.session.roomAgencyName ||
            this.session.locationType === 'REMOTE'
        );
    }

    hasTrainer(): boolean {
        return !!this.session.trainerFullName;
    }

    ngOnInit(): void {
        if (!this.session.id) {
            this.session.days = 1;
        } else {
            this.confirmed = this.session.confirmed || 0;
            this.options = this.session.options || 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/card/card.component.ts